import { useState } from "react";
import PageTItle from "../../layouts/PageTitle";
import ProductServices from "../../../services/ProductServices";
import Swal from "sweetalert2";

const MasterListBulk = () => {
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (
      file &&
      (file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel")
    ) {
      setSelectedFile(file);
    } else {
      Swal.fire({
        icon: "error",
        title: "Invalid File",
        text: "Please upload a valid Excel file.",
      });
      setSelectedFile(null);
    }
  };

  const handleFileUpload = async () => {
    if (!selectedFile) {
      // Show SweetAlert for validation error
      Swal.fire({
        icon: "warning",
        title: "No File Selected",
        text: "Please select a file before uploading.",
      });
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await ProductServices.bulkUpload(formData);
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "File uploaded successfully.",
      });
    } catch (error) {
      const errorMessage =
        error.response?.data?.error?.errorResponse?.message ||
        "File upload failed";
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage,
      });
    }
  };

  return (
    <>
      <PageTItle
        activeMenu="Master List Bulk Upload"
        motherMenu="Master List"
        pageContent="User"
      />
      <div className="col-xl-12 col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="basic-form">
              <form onSubmit={(e) => e.preventDefault()}>
                <div className="row">
                  <div className="col-xl-6 col-lg-6">
                    <div className="input-group">
                      <div className="form-file">
                        <input
                          type="file"
                          className="form-file-input form-control"
                          onChange={handleFileChange}
                        />
                      </div>
                      <button
                        className="btn btn-primary btn-sm"
                        type="button"
                        onClick={handleFileUpload}
                      >
                        Upload
                      </button>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6">
                    <button className="btn btn-primary">
                      Download Sample File
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MasterListBulk;
